import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from '@/app/AppLayout';
import { RoleGuard } from '@/app/RoleGuard';
import { routes as routeEntries } from '@/app/routes.generated';
import { NotImplementedPage } from '@/pages/NotImplementedPage';
import { TEMPLATE_BY_PAGE_TYPE } from '@/pages/templates';

// 156 個 route 全部由盤點結果產生（§13.1），不手寫。
// 登入頁不套 AppLayout：原系統登入頁沒有 navbar 與側邊選單。
const LOGIN_PATH = '/index';

const loginEntry = routeEntries.find((entry) => entry.path === LOGIN_PATH);

// FC-5：每個 route 套一層 RoleGuard，依 Session role 判定可達性（visibleTo 維度）。
// 登入頁不套——它本身就是 legacy 的 redirect 落點，套上去等於循環導頁。
const shellRoutes = routeEntries
  .filter((entry) => entry.path !== LOGIN_PATH)
  .map((entry) => {
    const Template = TEMPLATE_BY_PAGE_TYPE[entry.pageType];
    return {
      path: entry.path,
      element: (
        <RoleGuard route={entry}>
          <Template route={entry} />
        </RoleGuard>
      ),
    };
  });

function loginRoute() {
  if (loginEntry === undefined) return [];
  const LoginTemplate = TEMPLATE_BY_PAGE_TYPE[loginEntry.pageType];
  return [{ path: LOGIN_PATH, element: <LoginTemplate route={loginEntry} /> }];
}

export const router = createBrowserRouter([
  ...loginRoute(),
  {
    path: '/',
    element: <AppLayout />,
    children: [
      // 原系統的預設落點是 /main（menu_general.jsp 首頁群組的「一般首頁」）。
      { index: true, element: <Navigate to="/index" replace /> },
      ...shellRoutes,
      // 選單有、但盤點裡沒有對應頁面的功能（目前 1 個）。
      { path: '_/not-implemented', element: <NotImplementedPage /> },
      { path: '*', element: <NotImplementedPage /> },
    ],
  },
]);
